export enum DropdownItemType {
  TenderReduction = 'Tender/Auction',
  Agreement = 'Agreement',
  Order = 'Order',
  Receipt = 'Receipt',
  Task = 'Task',
  Document = 'Document',
  Process = 'Process In Work',
  Master = 'Master',
  PR = 'PR'
}
